import React from "react";

import useEscapeKey from "../hooks/useEscapeKey";

export const ToastContext = React.createContext();

function ToastProvider({ children }) {
  const [toasts, setToasts] = React.useState([]);

  const handleEscape = React.useCallback(() => {
    setToasts([]);
  }, []);

  useEscapeKey(handleEscape);

  React.useEffect(() => {
    if (toasts.length === 0) return;
    const nonErrorToasts = toasts.filter((t) => t.variant !== "error");
    if (nonErrorToasts.length === 0) return;
    const timer = setTimeout(() => {
      setToasts((prev) =>
        prev.filter(
          (t) => t.variant === "error" || t.id !== nonErrorToasts[0].id,
        ),
      );
    }, 3000);
    return () => clearTimeout(timer);
  }, [toasts]);

  function createToast(message, variant, solo) {
    const toast = {
      id: crypto.randomUUID(),
      message,
      variant,
    };
    if (solo) {
      setToasts([toast]);
    } else {
      setToasts((prev) => [...prev, toast]);
    }
    return toast.id;
  }

  function dismissToast(id) {
    setToasts((prev) => {
      return prev.filter((toast) => toast.id !== id);
    });
  }

  return (
    <ToastContext.Provider value={{ toasts, createToast, dismissToast }}>
      {children}
    </ToastContext.Provider>
  );
}

export default ToastProvider;
